module.exports = __webpack_public_path__ + "img/left_1.fdae09ce.jpg";